var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unreadMessageCount)?_c('div',{staticClass:"pill__num big-pulse-animation"},[_vm._v("\n  "+_vm._s(_vm.unreadMessageCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }